import script from "./RunGroupAddNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunGroupAddNew.vue?vue&type=script&setup=true&lang=ts"

import "./RunGroupAddNew.vue?vue&type=style&index=0&id=1c5a0bfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5a0bfa"]])

export default __exports__